export const MalwareAction = {
  TOGGLE_INIT_SCAN: "toggleInitScan",
};
